import { Link } from "react-router-dom";
import { categories } from "@/mocks/data";

interface BreadcrumbItem {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="flex items-center gap-1.5 text-sm">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <span key={index} className="flex items-center gap-1.5">
            {index > 0 && (
              <i className="ri-arrow-right-s-line text-foreground-400 text-xs"></i>
            )}
            {item.to && !isLast ? (
              <Link
                to={item.to}
                className="text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap"
              >
                {item.label}
              </Link>
            ) : (
              <span className={isLast ? "text-foreground-900 font-medium whitespace-nowrap" : "text-foreground-500 whitespace-nowrap"}>
                {item.label}
              </span>
            )}
          </span>
        );
      })}
    </nav>
  );
}

export function getCategoryBreadcrumb(slug?: string) {
  const items: BreadcrumbItem[] = [
    { label: "首页", to: "/" },
    { label: "分类浏览", to: "/category" },
  ];
  if (slug) {
    const cat = categories.find((c) => c.id === slug);
    if (cat) {
      items.push({ label: cat.name });
    }
  }
  return items;
}

export function getArticleBreadcrumb(articleTitle?: string) {
  const items: BreadcrumbItem[] = [
    { label: "首页", to: "/" },
    { label: "分类浏览", to: "/category" },
  ];
  if (articleTitle) {
    items.push({ label: articleTitle });
  }
  return items;
}